import { fmtTime, fmtAge, colorCls } from "@/lib/format";
import { useNow } from "@/hooks/useNow";
import { PriorityChip, useDropUnit } from "./PendingQueue";

function ActiveRow({ inc, selected, onSelect, onDropUnit, now }) {
  const { over, handlers } = useDropUnit(onDropUnit, inc.id);
  return (
    <div data-testid={`active-row-${inc.incident_number}`} onClick={() => onSelect(inc.id)} {...handlers}
      className={`row-hover cursor-pointer border-b border-border/60 px-2 py-1.5 ${selected ? "row-selected" : ""} ${over ? "drop-target" : ""}`}>
      <div className="flex items-center gap-2">
        <PriorityChip priority={inc.priority} compact />
        <span className="mono text-xs font-semibold whitespace-nowrap shrink-0">{inc.incident_number}</span>
        <span className="text-xs font-medium truncate min-w-0">{inc.call_type_name}</span>
        {inc.officer_initiated && <span className="chip border-teal-500/50 text-teal-700 dark:text-teal-300 shrink-0 whitespace-nowrap" title="Officer-initiated">OI</span>}
        <span className="ml-auto mono text-[11px] text-muted-foreground whitespace-nowrap shrink-0">{fmtTime(inc.received_at, false)} · {fmtAge(inc.received_at, now)}</span>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-muted-foreground truncate flex-1 min-w-[80px]" title={inc.location_raw}>{inc.location_pending || !inc.location_raw ? <span className="italic text-amber-600 dark:text-amber-300">Location Pending</span> : inc.location_raw}</span>
        <div className="flex gap-1 flex-wrap justify-end shrink-0 max-w-[65%]">
          {inc.assigned_units.map((u) => (
            <span key={u.unit_id} data-testid={`active-unit-chip-${u.call_sign}`} className={`chip mono whitespace-nowrap ${colorCls(u.status_color)}`}>{u.call_sign} · {u.status_label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ActiveCalls({ items, selectedId, onSelect, onDropUnit }) {
  const now = useNow(1000);
  return (
    <section className="pane h-full" data-testid="active-pane">
      <div className="pane-head">
        <span className="overline-label">Active Calls</span>
        <span className="mono text-xs text-muted-foreground" data-testid="active-count">{items.length} in progress</span>
      </div>
      <div className="flex-1 min-h-0 overflow-auto">
        {items.length === 0 ? <div className="p-4 text-xs text-muted-foreground" data-testid="active-empty">No active calls.</div>
          : items.map((inc) => <ActiveRow key={inc.id} inc={inc} selected={inc.id === selectedId} onSelect={onSelect} onDropUnit={onDropUnit} now={now} />)}
      </div>
    </section>
  );
}
